var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpectLine(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1627.535,
    height: 46,
    viewBox: "0 0 1627.535 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Linie_cu_cifre",
    "data-name": "Linie cu cifre",
    transform: "translate(-141 -3930)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M0,0H210.551",
    transform: "translate(168.168 3949.5)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M0,0H297.57",
    transform: "translate(429.282 3949.5)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M0,0H332.529",
    transform: "translate(779.148 3949.5)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M0,0H310.5",
    transform: "translate(1164.323 3949.5)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    d: "M0,0H237.676",
    transform: "translate(1527.323 3949.5)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_56",
    "data-name": "Ellipse 56",
    transform: "translate(141 3935)",
    fill: "#fff",
    stroke: "#8f6f6f",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 12.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    d: "M3411.354,4026.363l15,15-15,15",
    transform: "translate(-1661.354 -91.363)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1,
    transform: "translate(0 -170)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_196",
    "data-name": "Rectangle 196",
    width: 40,
    height: 40,
    rx: 5,
    transform: "translate(387 4106)",
    fill: "#f6cf85"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_195",
    "data-name": "Rectangle 195",
    transform: "translate(381 4100)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 35,
    height: 35,
    rx: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_1-2",
    "data-name": 1,
    transform: "translate(401 4130)",
    fill: "#8f6f6f",
    fontSize: 30,
    fontFamily: "SecondaRound-Black, Seconda Round",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6,
    y: 0
  }, "1"))), /*#__PURE__*/React.createElement("g", {
    id: "_3",
    "data-name": 3,
    transform: "translate(734 -170)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_196-2",
    "data-name": "Rectangle 196",
    width: 40,
    height: 40,
    rx: 5,
    transform: "translate(387 4106)",
    fill: "#72beb7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_195-2",
    "data-name": "Rectangle 195",
    transform: "translate(381 4100)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 35,
    height: 35,
    rx: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_3-2",
    "data-name": 3,
    transform: "translate(401 4130)",
    fill: "#8f6f6f",
    fontSize: 30,
    fontFamily: "SecondaRound-Black, Seconda Round",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8,
    y: 0
  }, "3"))), /*#__PURE__*/React.createElement("g", {
    id: "_2",
    "data-name": 2,
    transform: "translate(349 -170)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_196-3",
    "data-name": "Rectangle 196",
    width: 40,
    height: 40,
    rx: 5,
    transform: "translate(387 4106)",
    fill: "#ff91ab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_195-3",
    "data-name": "Rectangle 195",
    transform: "translate(381 4100)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 35,
    height: 35,
    rx: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_2-2",
    "data-name": 2,
    transform: "translate(401 4130)",
    fill: "#8f6f6f",
    fontSize: 30,
    fontFamily: "SecondaRound-Black, Seconda Round",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8,
    y: 0
  }, "2"))), /*#__PURE__*/React.createElement("g", {
    id: "_4",
    "data-name": 4,
    transform: "translate(1097 -170)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_196-4",
    "data-name": "Rectangle 196",
    width: 40,
    height: 40,
    rx: 5,
    transform: "translate(387 4106)",
    fill: "#eda751"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_195-4",
    "data-name": "Rectangle 195",
    transform: "translate(381 4100)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 35,
    height: 35,
    rx: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_4-2",
    "data-name": 4,
    transform: "translate(401 4130)",
    fill: "#8f6f6f",
    fontSize: 30,
    fontFamily: "SecondaRound-Black, Seconda Round",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8,
    y: 0
  }, "4"))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpectLine);
export default __webpack_public_path__ + "static/media/expectLine.32203e45a56be7e788f236fe898fbaea.svg";
export { ForwardRef as ReactComponent };